/**
 * 文创Icon
 */
export default function CircleAndSquare() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
      <path
        d="M6.00016 12C9.31387 12 12.0002 9.3137 12.0002 5.99999C12.0002 5.90085 11.9978 5.80227 11.993 5.70431C11.9834 5.50595 12.1372 5.33333 12.3358 5.33333H13.3335C14.0699 5.33333 14.6668 5.93028 14.6668 6.66666V13.3333C14.6668 14.0697 14.0699 14.6667 13.3335 14.6667H6.66683C5.93045 14.6667 5.3335 14.0697 5.3335 13.3333V12.3356C5.3335 12.137 5.50612 11.9832 5.70448 11.9928C5.80244 11.9976 5.90102 12 6.00016 12Z"
        fill="#FCFCFD"
      />
      <path
        d="M10.6668 6C10.6668 8.57732 8.57749 10.6667 6.00016 10.6667C3.42283 10.6667 1.3335 8.57732 1.3335 6C1.3335 3.42267 3.42283 1.33333 6.00016 1.33333C8.57749 1.33333 10.6668 3.42267 10.6668 6Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}
